<template>
  <div class="achievement-section desert-section">
    <div class="main-container">
      <div class="title-container">
        <h2>{{ t("home.argproducts.title") }}</h2>
        <button class="test-result-btn" @click="showModal = true">
          {{ t("home.argproducts.testResults") }}
          <div class="arrow-icon">
            <svg data-v-f316e37b="" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 8.66671L16.3333 12L13 15.3334" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M16.3334 12L7.66675 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
            </svg>
          </div>
        </button>
      </div>

      <div class="subtitle">
        <p>{{ t("home.argproducts.subtitle1") }}</p>
        <p>{{ t("home.argproducts.subtitle2") }}</p>
      </div>

      <div class="product-display mobile-only">
        <img src="../../assets/image/home/smzg-1.png" :alt="$t('Product.productAlt')" class="product-image" />
        <p class="product-name">{{ $t("home.argproducts.productName") }}</p>
      </div>

      <div class="cards-container">
        <!-- 第一张卡片（默认显示长方形） -->
        <div class="card card-1" :class="{ active: activeCard === 1 }" @mouseenter="handleCardHover(1)">
          <div class="card-background">
            <img src="../../assets/image/home/h2.webp" :alt="$t('home.argproducts.card1Alt')" class="bg-image" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.argproducts.card1Title") }}</h3>
              <p>{{ $t("home.argproducts.card1Desc") }}</p>
            </div>
          </div>
        </div>

        <!-- 第二张卡片 -->
        <div class="card card-2" :class="{ active: activeCard === 2 }" @mouseenter="handleCardHover(2)">
          <div class="card-background">
            <img src="../../assets/image/home/h1.webp" :alt="$t('home.product.card2Alt')" class="bg-image" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.argproducts.card2Title") }}</h3>
              <p>{{ $t("home.argproducts.card2Desc") }}</p>
            </div>
          </div>
        </div>

        <!-- 第三张卡片 -->
        <div class="card card-3" :class="{ active: activeCard === 3 }" @mouseenter="handleCardHover(3)">
          <div class="card-background">
            <img src="../../assets/image/home/h3.webp" :alt="$t('product.card3Alt')" class="bg-image" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.argproducts.card3Title") }}</h3>
              <p>{{ $t("home.argproducts.card3Desc") }}</p>
            </div>
          </div>
        </div>

        <!-- 第四张卡片 -->
        <div class="card card-4" :class="{ active: activeCard === 4 }" @mouseenter="handleCardHover(4)">
          <div class="card-background">
            <img src="../../assets/image/home/h4.webp" :alt="$t('home.product.card4Alt')" class="bg-image" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.argproducts.card4Title") }}</h3>
              <p>{{ $t("home.argproducts.card4Desc") }}</p>
            </div>
          </div>
        </div>
      </div>


      <!-- 测试结果模态框 -->
      <div v-if="showModal" class="modal-overlay" @click="showModal = false">
        <div class="modal-content" @click.stop>
          <div class="popup-content">
            <div class="heading">
              <svg data-v-a8966e29="" fill="none" height="63" viewBox="0 0 39 63" width="39"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-rule="evenodd" fill="#fff" fill-rule="evenodd">
                  <path
                    d="m38.9998 59.2903c-4.4923-3.0935-8.222-.3772-11.637 2.6945 4.4091 1.1978 9.0781 1.7411 11.637-2.6945z">
                  </path>
                  <path
                    d="m37.9196 56.6283c-.1993-5.4508-4.6048-6.822-9.1076-7.7289 1.6706 4.2525 4.0216 8.3232 9.1076 7.7289z">
                  </path>
                  <path
                    d="m30.9888 56.8341c-4.2148-3.462-8.1606-1.0706-11.8238 1.7014 4.2921 1.5662 8.8987 2.5022 11.8238-1.7014z">
                  </path>
                  <path
                    d="m27.0802 54.2495c2.6264-4.7804-.4508-8.2183-3.8501-11.3081-.7487 4.5072-.8202 9.2077 3.8501 11.3081z">
                  </path>
                  <path
                    d="m23.6689 54.1433c-3.1009-4.4872-7.5521-3.2724-11.8354-1.6138 3.6963 2.6856 7.8683 4.8516 11.8354 1.6138z">
                  </path>
                  <path
                    d="m19.2894 50.1407c4.0125-3.6946 2.1908-7.9337-.0472-11.9454-2.1456 4.0337-3.7107 8.4663.0472 11.9454z">
                  </path>
                  <path
                    d="m17.1583 49.6893c-2.191-4.9951-6.7919-4.6491-11.3126-3.8355 3.11804 3.3395 6.8018 6.2596 11.3126 3.8355z">
                  </path>
                  <path
                    d="m13.5015 44.8602c4.6282-2.8863 3.6243-7.3897 2.1692-11.7469-2.8565 3.5658-5.2166 7.6312-2.1692 11.7469z">
                  </path>
                  <path
                    d="m11.886 44.1849c-1.2068-5.3192-5.79012-5.8496-10.38307-5.9056 2.43027 3.8689 5.4954 7.4329 10.38307 5.9056z">
                  </path>
                  <path
                    d="m10.5116 36.368c4.9282-2.3374 4.4465-6.9262 3.4999-11.4207-3.246 3.2152-6.05606 6.9837-3.4999 11.4207z">
                  </path>
                  <path
                    d="m9.69056 37.8889c-.56658-5.425-5.05459-6.4958-9.609017-7.0969 1.953707 4.1301 4.573917 8.0328 9.609017 7.0969z">
                  </path>
                  <path
                    d="m8.4397 27.4759c5.3259-1.1771 5.8818-5.7574 5.9634-10.3499-3.8824 2.4087-7.46343 5.4539-5.9634 10.3499z">
                  </path>
                  <path
                    d="m7.39828 31.4762c1.54132-5.2322-2.20111-7.9308-6.18344-10.2203.23426 4.5629 1.17148 9.1692 6.18344 10.2203z">
                  </path>
                  <path
                    d="m10.5347 17.1984c5.4477.2728 7.1947-3.9976 8.4876-8.40543-4.381 1.29663-8.6397 3.28673-8.4876 8.40543z">
                  </path>
                  <path
                    d="m7.02706 23.0691c3.27384-4.3627.71164-8.1998-2.21845-11.7371-1.37633 4.3567-2.10932 8.9995 2.21845 11.7371z">
                  </path>
                  <path
                    d="m12.9185 9.43744c5.4453-.31418 6.7233-4.74758 7.5352-9.268495-4.2164 1.759855-8.2366 4.196115-7.5352 9.268495z">
                  </path>
                  <path
                    d="m9.44249 14.1438c4.09141-3.6071 2.36181-7.88451.21105-11.9436-2.23231 3.98643-3.89286 8.3841-.21105 11.9436z">
                  </path>
                </g>
              </svg>{{
                locale === "zh"
                  ? "康码蛋白质肥料测试成果"
                  : "Healthcode’s Light of Desert Test Results"
              }}<svg data-v-a8966e29="" fill="none" height="63" viewBox="0 0 39 63" width="39"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-rule="evenodd" fill="#fff" fill-rule="evenodd">
                  <path
                    d="m38.9998 59.2903c-4.4923-3.0935-8.222-.3772-11.637 2.6945 4.4091 1.1978 9.0781 1.7411 11.637-2.6945z">
                  </path>
                  <path
                    d="m37.9196 56.6283c-.1993-5.4508-4.6048-6.822-9.1076-7.7289 1.6706 4.2525 4.0216 8.3232 9.1076 7.7289z">
                  </path>
                  <path
                    d="m30.9888 56.8341c-4.2148-3.462-8.1606-1.0706-11.8238 1.7014 4.2921 1.5662 8.8987 2.5022 11.8238-1.7014z">
                  </path>
                  <path
                    d="m27.0802 54.2495c2.6264-4.7804-.4508-8.2183-3.8501-11.3081-.7487 4.5072-.8202 9.2077 3.8501 11.3081z">
                  </path>
                  <path
                    d="m23.6689 54.1433c-3.1009-4.4872-7.5521-3.2724-11.8354-1.6138 3.6963 2.6856 7.8683 4.8516 11.8354 1.6138z">
                  </path>
                  <path
                    d="m19.2894 50.1407c4.0125-3.6946 2.1908-7.9337-.0472-11.9454-2.1456 4.0337-3.7107 8.4663.0472 11.9454z">
                  </path>
                  <path
                    d="m17.1583 49.6893c-2.191-4.9951-6.7919-4.6491-11.3126-3.8355 3.11804 3.3395 6.8018 6.2596 11.3126 3.8355z">
                  </path>
                  <path
                    d="m13.5015 44.8602c4.6282-2.8863 3.6243-7.3897 2.1692-11.7469-2.8565 3.5658-5.2166 7.6312-2.1692 11.7469z">
                  </path>
                  <path
                    d="m11.886 44.1849c-1.2068-5.3192-5.79012-5.8496-10.38307-5.9056 2.43027 3.8689 5.4954 7.4329 10.38307 5.9056z">
                  </path>
                  <path
                    d="m10.5116 36.368c4.9282-2.3374 4.4465-6.9262 3.4999-11.4207-3.246 3.2152-6.05606 6.9837-3.4999 11.4207z">
                  </path>
                  <path
                    d="m9.69056 37.8889c-.56658-5.425-5.05459-6.4958-9.609017-7.0969 1.953707 4.1301 4.573917 8.0328 9.609017 7.0969z">
                  </path>
                  <path
                    d="m8.4397 27.4759c5.3259-1.1771 5.8818-5.7574 5.9634-10.3499-3.8824 2.4087-7.46343 5.4539-5.9634 10.3499z">
                  </path>
                  <path
                    d="m7.39828 31.4762c1.54132-5.2322-2.20111-7.9308-6.18344-10.2203.23426 4.5629 1.17148 9.1692 6.18344 10.2203z">
                  </path>
                  <path
                    d="m10.5347 17.1984c5.4477.2728 7.1947-3.9976 8.4876-8.40543-4.381 1.29663-8.6397 3.28673-8.4876 8.40543z">
                  </path>
                  <path
                    d="m7.02706 23.0691c3.27384-4.3627.71164-8.1998-2.21845-11.7371-1.37633 4.3567-2.10932 8.9995 2.21845 11.7371z">
                  </path>
                  <path
                    d="m12.9185 9.43744c5.4453-.31418 6.7233-4.74758 7.5352-9.268495-4.2164 1.759855-8.2366 4.196115-7.5352 9.268495z">
                  </path>
                  <path
                    d="m9.44249 14.1438c4.09141-3.6071 2.36181-7.88451.21105-11.9436-2.23231 3.98643-3.89286 8.3841-.21105 11.9436z">
                  </path>
                </g>
              </svg>
            </div>
            <div class="table-wrap">
              <div class="richtext">
                <table class="table type-body2">
                  <thead>
                    <tr class="table-row">
                      <th class="table-header" :width="locale === 'en' ? '20%' : '20%'">
                        <p>{{ locale === "zh" ? "项目地区" : "Region" }}</p>
                      </th>
                      <th class="table-header" :width="locale === 'en' ? '20%' : '20%'">
                        <p>{{ locale === "zh" ? "作物" : "Crop" }}</p>
                      </th>
                      <th class="table-header" :width="locale === 'en' ? '25%' : '25%'">
                        <p>{{ locale === "zh" ? "测试面积" : "Test Area" }}</p>
                      </th>
                      <th class="table-header" :width="locale === 'en' ? '35%' : '35%'">
                        <p>
                          {{
                            locale === "zh"
                              ? "增产效果"
                              : "Yield Increase Effect"
                          }}
                        </p>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="locale == 'zh'">
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="5">
                        <p>河南省夏邑</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>西瓜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="5">
                        <p>100亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>13.2%；</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>巨玫瑰葡萄</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>36.1%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>阳光玫瑰</p>
                        <p>葡萄</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>25%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>小麦</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>10.43%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>黄瓜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>21.7%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="6">
                        <p>上海崇明区</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>生菜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="6">
                        <p>2700亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>水稻</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>15%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>杭白菜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>鸡毛菜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>24.35%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>西葫芦</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>辣椒</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>26.41%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="4">
                        <p>上海浦东新区</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>小青菜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="4">
                        <p>100亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>10.4%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>生菜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>34.6%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>火龙果</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>17.5%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>葡萄</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>45.3%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="4">
                        <p>上海奉贤区</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>西兰花育苗</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="4">
                        <p>20亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>草莓</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>西红柿</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>黄瓜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>78%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="3">
                        <p>新疆莎车</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>玉米</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="3">
                        <p>1300亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>
                          突破性实现强盐碱地玉米种植难题。出苗率可达40%以上。
                        </p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>小麦</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>强盐碱地小麦种植出苗率可达80%以上。</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>碱蓬</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>
                          促进强盐碱土壤碱蓬生长活力。植株更浓绿健康。根系更发达，须根更多，柔韧性好，耐盐碱性更强，具备良好吸收能力（对照组根系木质化）。株高、单株重、根系长分别增加了43.81%、39.25%、19.73%。
                        </p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>新疆伊犁</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>冬小麦</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="6">
                        <p>560亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>47.1%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>新疆昌吉</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>棉花</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>3.3%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>新疆吐鲁番</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>西瓜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>17.9%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>新疆乌鲁木齐</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>西红柿</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>13.1%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>新疆吐鲁番</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>葡萄</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>5.48%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>新疆和田</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>油莎豆</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>实现纯沙漠区域的油莎豆种植，增产50%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>云南保山</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>牛油果</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="2">
                        <p>500亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>11.9%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>云南腾冲</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>工业辣椒</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p></p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>浙江安吉</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>白茶</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>2亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>10.14%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>北京</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>空心菜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>1亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>70%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="5">
                        <p>黑龙江哈尔滨</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>水稻</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="5">
                        <p>10亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>4.4%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>玉米</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>13.57%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>大豆</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>3%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>灵芝</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p></p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>珊瑚猴头菌菇</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>133.77%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>甘肃武威</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>娃娃菜</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>100亩</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <!-- 修复黑龙江鸡西部分 -->
                    <tr class="table-row">
                      <td class="table-cell" colspan="1" rowspan="3">
                        <p>黑龙江鸡西</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>玉米</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="3">
                        <p>2000亩</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>22%</p>
                      </td>
                    </tr>
                    <tr class="table-row">
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>大豆</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>17.1%</p>
                      </td>
                    </tr>
                    <tr class="table-row">
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>水稻</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>11%</p>
                      </td>
                    </tr>

                    <!-- 修复内蒙古鄂尔多斯部分 -->
                    <tr class="table-row">
                      <td class="table-cell" colspan="1" rowspan="2">
                        <p>内蒙古鄂尔多斯</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>鲜食玉米</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="2">
                        <p>100亩</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>23.6%</p>
                      </td>
                    </tr>
                    <tr class="table-row">
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>饲料玉米</p>
                      </td>
                      <td class="table-cell" colspan="1" rowspan="1">
                        <p>11.7%</p>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="5">
                        <p>Xiayi, Henan</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Watermelon</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="5">
                        <p>100mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>13.2%；</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Red Globe Grape</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>36.1%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Sunshine Rose Grape</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>25%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Wheat</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>10.43%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Cucumber</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>21.7%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="6">
                        <p>Chongming, Shanghai</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Lettuce</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="6">
                        <p>2700mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Rice</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>15%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Hangzhou Cabbage</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Shanghai Green</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>24.35%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Zucchini</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Chili</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>26.41%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="4">
                        <p>Pudong, Shanghai</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Bok Choy</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="4">
                        <p>100mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>10.4%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Lettuce</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>34.6%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Dragon Fruit</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>17.5%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Grape</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>45.3%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="4">
                        <p>Fengxian,Shanghai</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Broccoli Seedlings</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="4">
                        <p>20mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Strawberry</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Tomato</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Cucumber</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>78%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="3">
                        <p>Shache, Xinjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Corn</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="3">
                        <p>1300mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>
                         Breakthrough achievement in addressing the challenge of corn cultivation in highly saline-alkali soils, with a seedling emergence rate exceeding 40%.
                        </p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Wheat</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>The emergence rate of wheat in strong saline-alkali land can reach over 80%.</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Suaeda</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>
                         Enhance the growth vitality of salt-alkali resistant Suaeda salsa in strongly saline-alkali soils. The plants exhibit deeper green coloration and better health. The root system becomes more developed, with increased fine roots, greater flexibility, stronger salt-alkali tolerance, and improved absorption capacity (compared to the control group's lignified root system). Stem height, individual plant weight, and root length increased by 43.81%, 39.25%, and 19.73%, respectively.
                        </p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Yili, Xinjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Winter Wheat</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="6">
                        <p>560mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>47.1%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Changji, Xinjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Cotton</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>3.3%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Turpan, Xinjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Watermelon</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>17.9%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Urumqi, Xinjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Tomato</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>13.1%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Turpan, Xinjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Grape</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>5.48%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Hetian, Xinjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Tiger nut&nbsp;</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Realize the cultivation of oil soybeans in pure desert areas, increasing yield by 50%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Baoshan, Yunnan</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Avocado</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="2">
                        <p>500mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>11.9%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Tengchong, Yunnan</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Industrial Chili Pepper</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p></p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Ji’an, Zhejiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>White Tea</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>2mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>10.14%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Beijing</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Water Spinach</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>1mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>70%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="5">
                        <p>Harbin, Heilongjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Rice</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="5">
                        <p>10mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>4.4%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Corn</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>13.57%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Soybean</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>3%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Reishi Mushroom</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p></p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Hericium erinaceus</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>133.77%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Wuwei, Gansu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Baby Cabbage</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>100mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>20%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="3">
                        <p>Jixi, Heilongjiang</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Corn</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="3">
                        <p>2000mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>22%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Soybean</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>17.1%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Rice</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>11%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="2">
                        <p>Ordos, Inner Mongolia</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Corn</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="2">
                        <p>100mu</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>23.6%</p>
                      </td>
                    </tr>
                    <tr data-v-7f673fbe="" class="table-row">
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>Feed Corn</p>
                      </td>
                      <td data-v-9c75168d="" class="table-cell" colspan="1" rowspan="1">
                        <p>11.7%</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { locale, t } = useI18n();

// 当前激活的卡片
const activeCard = ref(1);

// 控制模态框显示
const showModal = ref(false);

// 测试结果数据
const testResults = ref([
  {
    title: t("product.testResult1Title"),
    description: t("product.testResult1Desc"),
  },
  {
    title: t("product.testResult2Title"),
    description: t("product.testResult2Desc"),
  },
  {
    title: t("product.testResult3Title"),
    description: t("product.testResult3Desc"),
  },
]);

// 处理卡片悬停
const handleCardHover = (cardId) => {
  activeCard.value = cardId;
};

// 组件挂载后设置默认激活状态
onMounted(() => {
  activeCard.value = 1;
});
</script>

<style scoped>
.achievement-section {
  padding: 2rem 0;
  box-sizing: border-box;
  background: linear-gradient(179deg,
      #e9e9e9 13.58%,
      #fff 79.31%,
      #c9c9c9eb 100.65%);
  position: relative;
  color: #333;
}

.title-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.title-container h2 {
  font-size: 2.5rem;
  font-weight: 500;
  margin: 0;
  color: #1a1a1a;
}

.test-result-btn {
  display: flex;
  flex-direction: row;
  background-color: #1a1a1a;
  color: white;
  border: none;
  padding: 0.4rem 1rem;
  border-radius: 1.5rem;
  font-size: 1.13rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.test-result-btn:hover {
  background-color: #333;
}

.subtitle {
  margin-bottom: 40px;
  line-height: 1.6;
  font-size: 16px;
  color: #555;
  width: 55%;
}

/* 横向排列的卡片容器 */
.cards-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  align-items: flex-end;
  height: 400px;
  position: relative;
  z-index: 4;
}

.card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: height 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 0.3s ease, box-shadow 0.3s ease;
  background: linear-gradient(90deg, #ecf3efcc, #fffc);
  border: 1px solid #e9ecef;
  cursor: pointer;
  width: 100%;
  height: 20rem;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

/* 激活状态的卡片显示为长方形（高度较大） */
.card.active {
  height: 30rem;
}

.card-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.card.active .bg-image {
  transform: scale(1.05);
}

.card-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  padding: 2rem;
  align-items: top;
  justify-content: flex-start;
  height: 100%;
  color: #000;
  transform: translateY(0);
  transition: all 0.3s ease;
}

/* 非激活卡片只显示文字，背景为纯色 */
.card:not(.active) .card-background {
  -webkit-backdrop-filter: blur(51.9500007629px);
  backdrop-filter: blur(51.9500007629px);
  background: linear-gradient(90deg, #ecf3efcc, #fffc);
  border: 1px solid hsla(0, 0%, 100%, 0.6);
}

.card:not(.active) .bg-image {
  opacity: 0;
}

.card:not(.active) .card-content {
  background: transparent;
  color: #000;
  display: flex;
  align-items: top;
  justify-content: flex-start;
  height: 100%;
  padding: 20px;
}

.text-content h3 {
  font-size: 2rem;
  color: #fff;
  margin: 0 0 10px 0;
  font-weight: 600;
}

.card:not(.active) .text-content h3 {
  font-size: 2rem;
  text-shadow: none;
  color: #83bd99;
}

.text-content p {
  font-size: 1.2rem;
  color: #fff;
  margin: 0;
  line-height: 1.5;
}

.card:not(.active) .text-content p {
  color: #000;
  text-shadow: none;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.card:not(.active):hover .bg-image {
  opacity: 0.2;
  transition: opacity 0.3s ease;
}

/* 产品展示 */
.product-display {
  text-align: center;
  margin: 40px auto;
  display: block;
  position: absolute;
  right: 10rem;
  top: 47%;
  transform: translateY(-50%);
  z-index: 0;
  width: 42rem;
}

.product-image {
  width: 40rem;
  height: auto;
  object-fit: contain;
  margin-bottom: 10px;
}

.product-name {
  font-size: 16px;
  color: #999;
  margin: 0;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #f6faf8;
  border-radius: 12px;
  width: calc(100% - 14rem * 2);
  max-width: 84rem;
  min-height: 60vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  /* 关键修复 */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.test-result-item {
  margin-bottom: 20px;
}

.test-result-item:last-child {
  margin-bottom: 0;
}

.test-result-item h4 {
  margin: 0 0 10px 0;
  color: #4a9d7c;
  font-size: 1.2rem;
}

.test-result-item p {
  margin: 0;
  color: #666;
  line-height: 1.6;
}

.modal-footer {
  padding: 20px;
  text-align: right;
  border-top: 1px solid #eee;
}

.confirm-btn {
  background-color: #4a9d7c;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}

.confirm-btn:hover {
  background-color: #3a8d6c;
}

.popup-content {
  background: #f6faf8;
  overflow-y: auto;
  border-radius: 12px;
  height: 100%;
  min-height: 80vh;
}

.popup-content .table-wrap {
  max-height: 60vh;
  /* border: 1px solid #e4e7e5; */
  /* border-radius: 8px; */
  margin: 1rem 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
  /* 使用 collapse 而不是 separate */
  font-family: HarmonyOSSansSC, sans-serif;
  color: #333;
  font-size: 1.4rem;
  margin: 0;
  /* border: 1px solid #e4e7e5;  */
}

/* 表头样式 */
.table-header {
  background-color: #fff;
  color: #85be9a;
  font-weight: 600;
  text-align: left;
  padding: 1.2rem;
  border: 1px solid #e4e7e5;
}

.popup-content .heading {
  align-items: center;
  background: linear-gradient(180deg, #83bd99, #f6faf8);
  color: #fff;
  display: flex;
  flex-direction: row;
  font-family: HarmonyOSSansSC;
  font-size: 2rem;
  font-weight: 400;
  height: 8rem;
  justify-content: center;
  letter-spacing: normal;
  line-height: 1;
  text-transform: none;
}

.popup-content .heading svg:last-child {
  transform: scaleX(-1);
}

/* 数据行样式 */
.table-row {
  border-bottom: 1px solid #e4e7e5;
}

/* 单元格样式 */
.table-cell,
.table-header {
  padding: 1.2rem;
  vertical-align: middle;
  text-align: left;
  border: 1px solid #e4e7e5;
  font-size: 1.2rem;
}
.card.active .bg-image {
  transform: scale(2);
}

/* 鼠标悬停时的图片放大 */
.card:hover .bg-image {
  transform: scale(2);
  transition: transform 0.5s ease;
}
@media (max-width: 1024px) {
  .cards-container {
    flex-wrap: wrap;
    height: auto;
    align-items: stretch;
    margin-right: 0;
    /* 小屏幕时取消右侧边距 */
  }

  .card {
    flex: 1 1 calc(50% - 20px);
    min-width: 200px;
  }

  .card.active {
    height: 30rem;
  }

  /* 桌面端产品图在小屏幕时隐藏 */
  .desktop-only {
    display: none;
  }
}

@media (max-width: 768px) {
  .achievement-section {
    padding: 4rem 0;
  }

  .title-container h2 {
    font-size: 2rem;
  }

  /* 移动端卡片布局 */
  .cards-container {
    flex-direction: column;
    gap: 15px;
    height: auto;
    margin-right: 0;
    position: static;
  }

  .subtitle {
    width: 100%;
    font-size: 1.4rem;
  }

  .card,
  .card.active {
    height: auto;
    width: 100%;
    min-height: 15rem;
    border: none;
    box-shadow: none;
    border-radius: 10px;
    padding: 1.5rem;
    cursor: default;
    transform: none;
    transition: none;
  }

  .card:not(.active) .card-background,
  .card.active .card-background {
    display: none;
  }

  .card-content {
    position: relative;
    padding: 0;
    height: auto;
    color: #000 !important;
  }

  .text-content h3 {
    font-size: 2rem;
    color: #83bd99 !important;
    text-shadow: none;
  }

  .text-content p {
    color: #000 !important;
    text-shadow: none;
    font-size: 14px;
  }

  /* 移动端产品展示控制 */
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
    margin: 20px 0 40px 0;
    position: static;
    /* 移动端取消绝对定位 */
    width: auto;
  }

  .mobile-only .product-image {
    width: 300px;
    margin: 0 auto;
  }

  /* 移动端产品展示容器取消绝对定位 */
  .product-display.mobile-only {
    position: static;
    width: auto;
    transform: none;
    margin: 20px auto 40px;
  }

  .table {
    font-size: 1.2rem;
  }

  .test-result-btn {
    padding: 0.6rem 1.4rem;
    font-size: 1.2rem;
  }
   .card-content{
    padding: 0;
  }
  .card:not(.active) {
    padding: 0;
  }
}

@media (max-width: 480px) {

  .card,
  .card.active {
    min-height: 80px;
  }

  .text-content h3 {
    font-size: 2rem;
  }

  .text-content p {
    font-size: 12px;
  }

  .mobile-only .product-image {
    width: 100%;
    max-width: 300px;
  }

  .modal-content {
    width: 95%;
  }

  .subtitle {
    width: 100%;
    font-size: 1.4rem;
  }

  .test-result-btn {
    padding: 0.6rem 1.4rem;
    font-size: 1.2rem;
  }
  .card-content{
    padding: 0;
  }
  .card:not(.active) {
    padding: 0;
  }
}

@media screen and (min-width: 1920px) {
  .card.active {
    height: 35rem;
  }

  .cards-container {
    height: 35rem;
  }
}
</style>
